import { useQuery, useQueryClient } from '@tanstack/react-query'
import { workerKeys } from './keys'
import { getRosterDetails } from 'api/worker'

export function useRosterDetail(rosterId: number) {
  return useQuery({
    queryKey: workerKeys.rosterDetail(rosterId),
    queryFn: () => getRosterDetails(rosterId),
  })
}

export function useInvalidateRosterDetail(rosterId: number) {
  const queryClient = useQueryClient()

  return {
    invalidate: () => {
      queryClient.invalidateQueries({
        queryKey: workerKeys.rosterDetail(rosterId),
      })
    },
  }
}
